// extracted by mini-css-extract-plugin
export default {"container":"GcdNHOgHpvGYT8gGyYqY","text":"LON9dmHp91VBz1hG7Hlk"};